import styled, { css } from 'styled-components'
import { noTouch } from '@/assets/styles/mixins.css.js'

const Language = styled.a`
  font-size: 14px;
  line-height: 114%;
  color: #aaa;
  text-decoration: none;
  text-transform: uppercase;
  transition: color 0.3s ease-out;
  cursor:pointer;

  ${noTouch()`
    &:hover {
      color: var(--color-decor);
    }
  `}

  ${props =>
    props.current &&
    css`
      color: var(--color-decor);
  `}
`

export default Language
